import { __values } from "tslib";
import { defineMetadata, getOwnMetadata } from '../localReflect';
import { isDisposable } from 'ts-disposables';
import constants from '../constants';
import { getDecoratorDependencies } from './getDecoratorDependencies';
import { createVueDecorator } from './shim-component-decorators';
export function decorateParameterOrProperty(keyProvider, name) {
    return function (target, propertyOrParameterName, index) {
        if (typeof index === 'number') {
            var params = getDecoratorDependencies(target, name);
            params[index] = keyProvider(params[index]);
        }
        else {
            var propertyType = getOwnMetadata(constants.propertyType, target, propertyOrParameterName);
            var resolverOrKey_1 = keyProvider(propertyType);
            defineMetadata(constants.resolver, resolverOrKey_1, target, propertyOrParameterName);
            return createVueDecorator(function (options, propertyName) {
                if (ensureInject(options)) {
                    options.inject[propertyName] = defaultInjectable(resolverOrKey_1);
                }
            })(target, propertyOrParameterName);
        }
    };
}
export function defaultInjectable(resolver) {
    return {
        default: function () {
            var disposable = this.__$disposable;
            var value = this.$container.get(resolver);
            if (value && isDisposable(value)) {
                disposable.add(value);
            }
            return value;
        },
    };
}
function ensureInject(options) {
    var e_1, _a;
    if (!options.inject)
        options.inject = {};
    if (Array.isArray(options.inject)) {
        var currentInject = options.inject;
        options.inject = {};
        try {
            for (var currentInject_1 = __values(currentInject), currentInject_1_1 = currentInject_1.next(); !currentInject_1_1.done; currentInject_1_1 = currentInject_1.next()) {
                var item = currentInject_1_1.value;
                options.inject[item] = item;
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (currentInject_1_1 && !currentInject_1_1.done && (_a = currentInject_1.return)) _a.call(currentInject_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
    }
    return true;
}
//# sourceMappingURL=data:application/json;base64,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